import { Directive, OnInit, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[required-asterisk]'
})
export class MarkAsteriskDirective implements OnInit {

    constructor(private renderer: Renderer2, private el: ElementRef) { }

    ngOnInit() {
        const parent = this.renderer.parentNode(this.el.nativeElement);

        if (parent.getElementsByTagName('LABEL').length && !parent.getElementsByClassName('required-asterisk').length) {
            const span = document.createElement('span');
            span.classList.add("required-asterisk");
            span.innerHTML = '*';
            parent.getElementsByTagName('LABEL')[0].after(span);
        }
    }
}